import React, { useEffect } from "react";
import { FaClock } from "react-icons/fa";

const Timer = ({
  question,
  time,
  minutes,
  setMinutes,
  seconds,
  setSeconds,
}) => {
  const time_now = time + Date.now();

  const getTime = () => {
    const deadLine = time_now - Date.now();

    setMinutes(Math.floor((deadLine / 1000 / 60) % 60));
    setSeconds(Math.floor((deadLine / 1000) % 60));
  };

  useEffect(() => {
    const interval = setInterval(() => getTime(), 1000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [question]);

  return (
    <div
      className={`${
        minutes < 1 ? "text-red-500" : "text-secondary"
      } flex flex-row gap-2 items-center justify-center`}
    >
      <FaClock className="text-[20px] leading-[24px]" />
      <span className="text-[24px] leading-[24px]">
        {minutes < 10 ? "0" + minutes : minutes}
      </span>
      <span className="text-[24px] leading-[24px]">:</span>
      <span className="text-[24px] leading-[24px]">
        {seconds < 10 ? "0" + seconds : seconds}
      </span>
    </div>
  );
};

export default Timer;
